const n = "{{currentTime}} allan o {{duration}}", o = "Canlyniad chwilio {{current}} o {{total}}", t = "Heb ddod o hyd i ganlyniadau", a = "Wedi dod o hyd i {{count}} canlyniad", i = "{{count}} canlyniad wedi’u canfod", s = 'Yn chwarae o $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) a $t(SECONDS, { "count": {{seconds}} }).', c = 'Yn chwarae o $t(MINUTES, { "count": {{minutes}} }) a $t(SECONDS, { "count": {{seconds}} }).', A = 'Yn chwarae o $t(SECONDS, { "count": {{seconds}} }).', E = "Cafwyd gwall wrth gadw’r newidiadau i'r trawsgrifiad.", T = "Llinell trawsgrifiad yn {{time}}. Cynnwys yw: {{text}}.", _ = 'Cynhwysydd llinellau trawsgrifiad. Mae $t(TRANSCRIPT_LINES, { "count": {{count}} }) yn y cynhwysydd hwn. I lywio yn y cynhwysydd hwn defnyddiwch y fysell saeth i lawr.', d = "Wrthi’n cadw newidiadau...", e = "Wedi cadw'r newidiadau i'r trawsgrifiad.", S = "Mae’r botwm diweddaru capsiynau bellach ar gael.", r = "Tasg", C = "Ychwanegu anodiad am {{time}}", l = "Ychwanegu cwestiwn am {{time}}", w = "Anodiadau", N = "Awtomatig", R = "Awtomatig ({{quality}})", I = "Yn ôl", y = "Capsiynau", O = "Iaith y Capsiwn", u = "Rheoli Capsiynau", h = "Dileu {{language}}", P = "Maint Ffont", U = "Iaith Capsiwn: {{language}}", L = "{{language}} (awtomatig)", D = "Clirio'r Chwiliad", g = "Cau", M = "Sylwadau", f = "Bwrw ymlaen", Y = "Arafu’r Cyflymder Chwarae", m = "Lleihau’r sain {{percent}}%", G = "Saeth i Lawr", H = "Cau Golygydd Trawsgrifiad", B = "Diweddaru Capsiynau", p = "Gwall!", W = "Wrthi’n cadw...", V = "Wedi cadw!", F = "Golygu Trawsgrifiad", K = "Ni all y testun fod yn wag!", b = "Sgrin Lawn", $ = "{{count}} awr", Q = "{{count}} awr", J = "Cyflymu’r Cyflymder Chwarae", x = "Cynyddu’r sain {{percent}}%", Z = "Gwrth-droi Lliwiau", X = "Neidio i ganran benodol (1-10%, 2-20%, ac ati)", q = "Neidio i’r cychwyn", v = "Tasgau ar gyfer {{title}}", j = "Bysellau Hwylus", k = "Iaith", z = "Saeth i’r Chwith", nn = "Prif Ddewislen", on = "{{count}} munud", tn = "{{count}} munud", an = "Tewi", sn = "Wedi'i dewi", cn = "Iaith Capsiwn Nesaf", An = "Y canlyniad chwilio nesaf", En = "Diffodd", Tn = "Ar y Brig", _n = "Agor anodiad am {{time}}", dn = "Agor cwis wedi’i gwblhau am {{time}}", en = "Agor cwis am {{time}}", Sn = "Rhewi", rn = "Chwarae", Cn = "Cyflymder Chwarae", ln = "Cyflymder Chwarae: {{speed}}x", wn = "Iaith Capsiwn Blaenorol", Nn = "Y canlyniad chwilio blaenorol", Rn = "Ansawdd", In = "Dewislen Ansawdd", yn = "Ailadrodd", On = "Ailosod Cyflymder Chwarae", un = "Saeth i’r Dde", hn = "Chwilio yn y trawsgrifiad", Pn = "{{count}} eiliad", Un = "{{count}} eiliad", Ln = "Chwilio yn ôl: {{seconds}} eiliad", Dn = "Chwilio ymlaen: {{seconds}} eiliad", gn = "Gosodiadau", Mn = "Llwybr byr", fn = "Manylion cyfryngau a chyfarpar", Yn = "Bwlch", mn = "Dewislen cyflymder chwarae", Gn = "Dechrau Sgrolio’n Awtomatig", Hn = "Toglo Capsiynau", Bn = "Toglo wedi’i dewi", pn = "Toglo Chwarae/Rhewi", Wn = "yn {{count}} llinell trawsgrifiad", Vn = "yn {{count}} llinell trawsgrifiad", Fn = "Wrthi’n llwytho'r trawsgrifiad...", Kn = "Wedi methu llwytho'r trawsgrifiad.", bn = "Opsiynau Trawsgrifiad", $n = "Ailgynnig", Qn = "Trawsgrifiad ddim ar gael", Jn = "Saeth i fyny", xn = "Gosodiadau Fideo", Zn = "Sain", Xn = "Sain: {{volume}}%", qn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: o,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: a,
  A11Y_SEARCH_RESULTS_FOUND_other: i,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: c,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: T,
  A11Y_TRANSCRIPT_LINES: _,
  A11Y_TRANSCRIPT_SAVING: d,
  A11Y_TRANSCRIPT_SUCCESS: e,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: r,
  ADD_ANNOTATION_AT: C,
  ADD_QUESTION_AT: l,
  ANNOTATIONS: w,
  AUTO: N,
  AUTO_QUALITY: R,
  BACK: I,
  CAPTIONS: y,
  CAPTIONS_LANGUAGE: O,
  CAPTIONS_MANAGE: u,
  CAPTION_DELETE: h,
  CAPTION_FONT_SIZE: P,
  CAPTION_LANGUAGE: U,
  CAPTION_LANGUAGE_AUTOMATIC: L,
  CLEAR_SEARCH: D,
  CLOSE: g,
  COMMENTS: M,
  CONTINUE: f,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: m,
  DOWN_ARROW: G,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: B,
  EDIT_ERROR: p,
  EDIT_SAVING: W,
  EDIT_SUCCESS: V,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: b,
  HOURS: $,
  HOURS_other: Q,
  INCREASE_PLAYBACK_SPEED: J,
  INCREASE_VOLUME: x,
  INVERT_COLORS: Z,
  JUMP_TO_PERCENTAGE: X,
  JUMP_TO_START: q,
  KEBAB_MENU: v,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: z,
  MAIN_MENU: nn,
  MINUTES: on,
  MINUTES_other: tn,
  MUTE: an,
  MUTED: sn,
  NEXT_CAPTION_LANGUAGE: cn,
  NEXT_HIT: An,
  OFF: En,
  ON_TOP: Tn,
  OPEN_ANNOTATION_AT: _n,
  OPEN_COMPLETED_QUIZ_AT: dn,
  OPEN_QUIZ_AT: en,
  PAUSE: Sn,
  PLAY: rn,
  PLAYBACK_SPEED: Cn,
  PLAYBACK_SPEED_MESSAGE: ln,
  PREVIOUS_CAPTION_LANGUAGE: wn,
  PREVIOUS_HIT: Nn,
  QUALITY: Rn,
  QUALITY_MENU: In,
  REPLAY: yn,
  RESET_PLAYBACK_SPEED: On,
  RIGHT_ARROW: un,
  SEARCH_TRANSCRIPT_PLACEHOLDER: hn,
  SECONDS: Pn,
  SECONDS_other: Un,
  SEEK_BACKWARD: Ln,
  SEEK_FORWARD: Dn,
  SETTINGS: gn,
  SHORTCUT: Mn,
  SIDEBAR: fn,
  SPACE: Yn,
  SPEED_MENU: mn,
  START_AUTOSCROLL: Gn,
  TOGGLE_CAPTIONS: Hn,
  TOGGLE_MUTED: Bn,
  TOGGLE_PLAY_PAUSE: pn,
  TRANSCRIPT_LINES: Wn,
  TRANSCRIPT_LINES_other: Vn,
  TRANSCRIPT_LOADING: Fn,
  TRANSCRIPT_LOAD_ERROR: Kn,
  TRANSCRIPT_OPTIONS: bn,
  TRANSCRIPT_RETRY: $n,
  TRANSCRIPT_UNAVAILABLE: Qn,
  UP_ARROW: Jn,
  VIDEO_SETTINGS: xn,
  VOLUME: Zn,
  VOLUME_VALUE: Xn
};
export {
  n as A11Y_DURATION,
  o as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  a as A11Y_SEARCH_RESULTS_FOUND,
  i as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  c as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  T as A11Y_TRANSCRIPT_LINE,
  _ as A11Y_TRANSCRIPT_LINES,
  d as A11Y_TRANSCRIPT_SAVING,
  e as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  r as ACTION,
  C as ADD_ANNOTATION_AT,
  l as ADD_QUESTION_AT,
  w as ANNOTATIONS,
  N as AUTO,
  R as AUTO_QUALITY,
  I as BACK,
  y as CAPTIONS,
  O as CAPTIONS_LANGUAGE,
  u as CAPTIONS_MANAGE,
  h as CAPTION_DELETE,
  P as CAPTION_FONT_SIZE,
  U as CAPTION_LANGUAGE,
  L as CAPTION_LANGUAGE_AUTOMATIC,
  D as CLEAR_SEARCH,
  g as CLOSE,
  M as COMMENTS,
  f as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  m as DECREASE_VOLUME,
  G as DOWN_ARROW,
  H as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  p as EDIT_ERROR,
  W as EDIT_SAVING,
  V as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  b as FULLSCREEN,
  $ as HOURS,
  Q as HOURS_other,
  J as INCREASE_PLAYBACK_SPEED,
  x as INCREASE_VOLUME,
  Z as INVERT_COLORS,
  X as JUMP_TO_PERCENTAGE,
  q as JUMP_TO_START,
  v as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  z as LEFT_ARROW,
  nn as MAIN_MENU,
  on as MINUTES,
  tn as MINUTES_other,
  an as MUTE,
  sn as MUTED,
  cn as NEXT_CAPTION_LANGUAGE,
  An as NEXT_HIT,
  En as OFF,
  Tn as ON_TOP,
  _n as OPEN_ANNOTATION_AT,
  dn as OPEN_COMPLETED_QUIZ_AT,
  en as OPEN_QUIZ_AT,
  Sn as PAUSE,
  rn as PLAY,
  Cn as PLAYBACK_SPEED,
  ln as PLAYBACK_SPEED_MESSAGE,
  wn as PREVIOUS_CAPTION_LANGUAGE,
  Nn as PREVIOUS_HIT,
  Rn as QUALITY,
  In as QUALITY_MENU,
  yn as REPLAY,
  On as RESET_PLAYBACK_SPEED,
  un as RIGHT_ARROW,
  hn as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Pn as SECONDS,
  Un as SECONDS_other,
  Ln as SEEK_BACKWARD,
  Dn as SEEK_FORWARD,
  gn as SETTINGS,
  Mn as SHORTCUT,
  fn as SIDEBAR,
  Yn as SPACE,
  mn as SPEED_MENU,
  Gn as START_AUTOSCROLL,
  Hn as TOGGLE_CAPTIONS,
  Bn as TOGGLE_MUTED,
  pn as TOGGLE_PLAY_PAUSE,
  Wn as TRANSCRIPT_LINES,
  Vn as TRANSCRIPT_LINES_other,
  Fn as TRANSCRIPT_LOADING,
  Kn as TRANSCRIPT_LOAD_ERROR,
  bn as TRANSCRIPT_OPTIONS,
  $n as TRANSCRIPT_RETRY,
  Qn as TRANSCRIPT_UNAVAILABLE,
  Jn as UP_ARROW,
  xn as VIDEO_SETTINGS,
  Zn as VOLUME,
  Xn as VOLUME_VALUE,
  qn as default
};
